export const user = {
  loggedIn: false,
  id: null,
}
